import React,{useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import DashboardHeader from '../dashboardHeader'
import DashBoardContainer from '../../../components/containers/dashboardContainer'
import {SUBMIT_FIRM_APPLICATION_ID} from '../../../store/loaders'
import { v4 as uuidv4 } from 'uuid'
import CompanyProfile from '../../../components/companyImage/companyProfile'







import TextArea from '../../../components/textarea'
import TextField from '../../../components/textField'
import DatePicker from '../../../components/datePicker'
import {
    submitFirmApplication,
    updateFirmApplication,
    fetchFirmApplicationStatus as fetchFirmApplication
} from '../../../actions'



const CompanyDetails = (props)=>{


    const apiResponse = useSelector((state=>{
        const {
            firmApplication,
            loader,
            firmApplicationSubmitted,
            updatedFirmApplication,
            hasUpdatedFirm
        } = state
        const {application} = firmApplication
        const {isLoading} = loader[SUBMIT_FIRM_APPLICATION_ID] || {isLoading: false}
        const {response} = firmApplicationSubmitted
        const {status} = updatedFirmApplication
        const {updateId} = hasUpdatedFirm
        return{
            application,
            isLoading,
            response,
            status,
            updateId
        }
    }))


    const history = useHistory()
    const dispatch = useDispatch()


    var applicationId  = apiResponse.application?.id  ||  apiResponse.application?.applicationId
    var actionLoader = apiResponse.isLoading
    const appId = props.location.state && props.location.state.application?.id
    const isMember = props.location.state && props.location.state?.isMember


    const [applicationDetails, setApplicationDetails] = useState({
        companyNames: null,
        companyActivities: null,
        businessCertificateNumber: null,
        registrationDate: null,
    })

    const [requestId, setRequestId] = useState('')
    const [tempAvatarImage,
        setTempAvatarImage] = useState();
      const [croppedImagePath,
          setCroppedImagePath] = useState();
      const [isCropImageModalVisible,
          setIsCropImageModalVisible] = useState(false);
    

    useEffect(()=>{
        dispatch(fetchFirmApplication(appId))
    },[])


    useEffect(()=>{
        dispatch(fetchFirmApplication(appId))
        if(apiResponse.updateId === requestId && apiResponse.response?.status === 'success'){
            history.push({
                pathname: '/dashboard',
                state: applicationDetails
            })
        }
    },[apiResponse.response,apiResponse.updateId])

    useEffect(()=>{
        if(apiResponse.application?.id){
            setApplicationDetails({
                ...apiResponse.application,
            })
        }
    },[apiResponse.application])


    useEffect(()=>{
        if(croppedImagePath){
            setApplicationDetails({
                ...applicationDetails,
                portraitPhotoFile: {
                    fileText: croppedImagePath.split(',')[1],
                    type: croppedImagePath?.split(';')[0]?.split('/')?.pop(),
                    name: croppedImagePath?.split(';')[0]?.split('/')?.pop(),
                    changed: true
                  }
            })
        }
    },[croppedImagePath])

    const handleSaveForLater = ()=>{

        const reqId = uuidv4()
        setRequestId(reqId)

        const sentData= {
            ...applicationDetails,
            status: 'not submitted',
        }
        if(applicationId){
            dispatch(updateFirmApplication({
                data:{
                    ...sentData
                },
                id: applicationId,
                reqId: reqId
            }))
        }
        else{
            dispatch(submitFirmApplication({
                data:{
                    ...sentData
                },
                id: applicationId,
                reqId: reqId
            }))
        }
    }
    
    const handleSubmit = ()=>{
        history.push({
            pathname: '/applicant/company/contacts',
            state: {
                application: applicationDetails
            }
        })
        handleSaveForLater()
    }
    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant',
            state: {
                application: applicationDetails
            }
        })
     }

    const handleMembership = () => {
    }
     const handleCloseMembership = ()=>{
        history.goBack()
    }

    return (
        <div>
            {!isMember &&<DashboardHeader
                activeStep={2}
                title="Firm membership"/>}
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                handleSaveForLater={handleSaveForLater}
                middleTitle="Save for Later"
                title="Next"
                hasCloseBtn={isMember ? true: false}
                hasButton={isMember ? true: false}
                handleClose={handleMembership}
                handleCloseMembership={handleCloseMembership}
                disabled={actionLoader}>
                <div className="first-step-container" >
                    <div style={{width: '50%',}}>
                        <div style={{
                             display: 'flex',
                             alignItems: 'center',
                             flexDirection: 'column',}}>
                            <TextField 
                                title="Company Name"
                                handleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    companyNames:text.target.value
                                })}
                                value={applicationDetails.companyNames}
                                type="text"
                                required={true}
                                />
                            <TextArea
                                title="Company Activities"
                                handleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    companyActivities: text.target.value
                                })}
                                value={applicationDetails.companyActivities}
                                type="text"
                                required={true}
                            />
                            <CompanyProfile
                                title="Uplaod image"
                                required={true}
                                applicationDetails={applicationDetails}
                                tempAvatarImage={tempAvatarImage}
                                setTempAvatarImage={setTempAvatarImage}
                                croppedImagePath={croppedImagePath}
                                setCroppedImagePath={setCroppedImagePath}
                                isCropImageModalVisible={isCropImageModalVisible}
                                setIsCropImageModalVisible={setIsCropImageModalVisible}
                                />
                        </div>
                    </div>
                    <div className="vertical-seperator"></div>
                    <div style={{
                        width: '50%',
                        marginBottom: 20,
                        paddingLeft: 20
                        }}>
                        <div style={{
                             display: 'flex',
                             alignItems: 'center',
                             flexDirection: 'column'}}>
                            <DatePicker 
                                title="Date of business registration"
                                handleDateOfBirth={(date)=>setApplicationDetails({
                                    ...applicationDetails,
                                    registrationDate:date
                                })}

                                dateOfBirth={applicationDetails?.registrationDate || null}
                                value={applicationDetails.registrationDate}
                                required={true}
                            />
                            <TextField 
                                title="Business Certificate number"
                                placeholder="jmugabo@gmail.com"
                                handleChange={(text)=>setApplicationDetails({
                                    ...applicationDetails,
                                    businessCertificateNumber: text.target.value
                                })}
                                value={applicationDetails.businessCertificateNumber}
                                type="number"
                                required={true}
                                />
                        </div>
                    </div>
                </div>
            </DashBoardContainer>
        </div>
    )
}

export default CompanyDetails